import { render, staticRenderFns } from "./reserveSta.vue?vue&type=template&id=77a4b899&scoped=true&"
import script from "./reserveSta.vue?vue&type=script&lang=js&"
export * from "./reserveSta.vue?vue&type=script&lang=js&"
import style0 from "./reserveSta.vue?vue&type=style&index=0&id=77a4b899&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a4b899",
  null
  
)

export default component.exports